import React, { useEffect, useState } from 'react'
import Header from '../Core/Header'
import { getProfile, updateProfile } from '../../Services/Operations/ProductAPI'
import { useSelector } from 'react-redux'
import { baseURLImg } from '../../Services/api_endpoints'

const Profile = () => {
        const[userDetails,setUserDetails]=useState(null)
            const token = useSelector((state) => JSON.parse(state.auth.token));
            const[state,setState]=useState("view")
            const[fname,setFName]=useState(userDetails?.first_name||"")
             const[lname,setLName]=useState(userDetails?.last_name||"")
            const[email,setEmail]=useState(userDetails?.email||"")
            const[dob,setDob]=useState(userDetails?.dob||"")
            const[aadhar,setAadhar]=useState(userDetails?.aadhaar_id||"")
            const[medicalId,setmedicalId]=useState(userDetails?.medical_id||"")

               const handleGetProfile=async()=>{
                    try {
                      const res=await getProfile(token)
                      console.log(res);
                      if(res.status===200){
                        setUserDetails(res.data.data.user)
                      }
                      
                    } catch (error) {
                      console.log(error);
                      
                    }
                   }
              const handleUpdateProfile=async()=>{
                try {
                  const formData=new FormData()
                  formData.append("first_name",fname)
                   formData.append("last_name",lname)
                    formData.append("email",email)
                    
                      const res= await updateProfile(formData,token)
                      console.log(res);
                      handleGetProfile()
                      setState('view')
                      
                  
                } catch (error) {
                  console.log(error);
                  
                }
              }

              useEffect(() => {
                 handleGetProfile()
              }, [])
              
            
            
                  useEffect(() => {
                   
                    setFName(userDetails?.first_name)
                    setLName(userDetails?.last_name)
                    setEmail(userDetails?.email)
                    setDob(dob)
                    setAadhar(userDetails?.aadhaar_id)
                    setmedicalId(userDetails?.medical_id)
                  }, [userDetails])
  return (
     <div style={{height:"100vh",width:"100%",overflow:"hidden"}}>
        <Header/>
        <div style={{width:"100%",height:"100vh",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column"}}>
            <p style={{fontSize:"24px",fontWeight:"500"}}>Profile Details</p>


            <div style={{display:"flex",alignItems:"center",justifyContent:"center",width:"70%",height:"60vh",overflowY:"scroll",padding:"10px",borderRadius:"8px",backgroundColor:"#b4d6fd"}}>
                <div style={{flex:1,height:"100%",width:"50%"}}>
                    <img src={baseURLImg+userDetails?.profile_image}
                    style={{height:"100%",width:"100%",margin:"12px"}}/>
                </div>
                <div style={{height:"100%",position:"relative",flex:1,margin:"12px",display:"flex",flexDirection:"column",justifyContent:"center",gap:"10px",padding:"20px",}}>
                    <p style={{position:"absolute",top:"15px",right:"15px",cursor:"pointer",borderRadius:"4px",padding:"6px",backgroundColor:"#b4fadf",fontWeight:"500"}}>{state==="view"?<span onClick={()=>setState('update')}>Update</span>
                    :
                    <span onClick={()=>handleUpdateProfile()}>Save</span>}</p>

                    {state==="view"?<div>
                    <p style={{fontWeight:"500",fontStyle:"italic"}}>Name:<span style={{fontStyle:"normal",margin:"0px 20px"}}>{userDetails?.name}</span></p>
                     <p style={{fontWeight:"500",fontStyle:"italic"}}>Email:<span style={{fontStyle:"normal",margin:"0px 20px"}}>{userDetails?.email}</span></p>
                      <p style={{fontWeight:"500",fontStyle:"italic"}}>Date of Birth:<span style={{fontStyle:"normal",margin:"0px 20px"}}>{userDetails?.dob}</span></p>
                      <p style={{fontWeight:"500",fontStyle:"italic"}}>Aadhaar:<span style={{fontStyle:"normal",margin:"0px 20px"}}>{userDetails?.aadhaar_id}</span></p>
                       <p style={{fontWeight:"500",fontStyle:"italic"}}>Medical Id:<span style={{fontStyle:"normal",margin:"0px 20px"}}>{userDetails?.medical_id}</span></p>
               </div>:
                 <div>
                    <p style={{fontWeight:"500",fontStyle:"italic",paddingBottom:"6px"}}>First Name:<input style={{fontStyle:"normal",margin:"0px 20px",border:"0.3px solid grey",outline:"none"}}
                    value={fname} onChange={(e)=>setFName(e.target.value)}/></p>
                    <p style={{fontWeight:"500",fontStyle:"italic",paddingBottom:"6px"}}>Last Name:<input style={{fontStyle:"normal",margin:"0px 20px",border:"0.3px solid grey",outline:"none"}}
                    value={lname} onChange={(e)=>setLName(e.target.value)}/></p>
                     <p style={{fontWeight:"500",fontStyle:"italic",paddingBottom:"6px"}}>Email:<input style={{fontStyle:"normal",margin:"0px 20px",border:"0.3px solid grey"}}
                     value={email} onChange={(e)=>setEmail(e.target.value)}/></p>
                      <p style={{fontWeight:"500",fontStyle:"italic",paddingBottom:"6px"}}>Date of Birth:<input style={{fontStyle:"normal",margin:"0px 20px",border:"0.3px solid grey"}}
                      value={dob} onChange={(e)=>setDob(e.target.value)} type='date'/></p>
                      <p style={{fontWeight:"500",fontStyle:"italic",paddingBottom:"6px"}}>Aadhaar<input style={{fontStyle:"normal",margin:"0px 20px",border:"0.3px solid grey"}}
                      value={aadhar} onChange={(e)=>setAadhar(e.target.value)}/></p>
                       <p style={{fontWeight:"500",fontStyle:"italic",paddingBottom:"6px"}}>Medical Id:<input style={{fontStyle:"normal",margin:"0px 20px",border:"0.3px solid grey"}}
                       value={medicalId} onChange={(e)=>setmedicalId(e.target.value)}/></p>
               </div>}
                </div>

            </div>


        </div>
      
    </div>
  )
}

export default Profile
